export const POLLING_INTERVAL = 5000;

export const STEP_STATE = {
  DONE: 'DONE',
  RUNNING: 'RUNNING',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
} as const;

export type StepState = (typeof STEP_STATE)[keyof typeof STEP_STATE];

export const STEP_BADGE_CLASS_NAME =
  'grid size-5 place-items-center rounded-full border';

export const DONE_STEP_BADGE_CLASS_NAME =
  'sborder-primary-default bg-surface-primary-subtle-default stext-primary-default';

export const FAILED_STEP_BADGE_CLASS_NAME =
  'sborder-danger-default bg-surface-danger-subtle-default stext-danger-default';

export const PENDING_STEP_BADGE_CLASS_NAME =
  'sborder-base-default bg-surface-muted-default text-xs font-bold stext-muted-default';
